// Getters
export const COMPETENCES_SEARCH_RESULT = 'contract_closing/COMPETENCES_SEARCH_RESULT'
export const CLOSING_EXCEPTIONS_SEARCH_RESULT = 'contract_closing/CLOSING_EXCEPTIONS_SEARCH_RESULT'
export const CURRENT_COMPETENCE = 'contract_closing/CURRENT_COMPETENCE'
export const CLOSING_EXCEPTION_CATEGORIES = 'contract_closing/CLOSING_EXCEPTION_CATEGORIES'

// Mutations
export const MUTATE_COMPETENCES_SEARCH_RESULT = 'contract_closing/MUTATE_COMPETENCES_SEARCH_RESULT'
export const MUTATE_CLOSING_EXCEPTIONS_SEARCH_RESULT = 'contract_closing/MUTATE_CLOSING_EXCEPTIONS_SEARCH_RESULT'
export const MUTATE_CURRENT_COMPETENCE = 'contract_closing/MUTATE_CURRENT_COMPETENCE'
export const MUTATE_CLOSING_EXCEPTION_CATEGORIES = 'contract_closing/MUTATE_CLOSING_EXCEPTION_CATEGORIES'

// Actions
export const SEARCH_COMPETENCES = 'contract_closing/SEARCH_COMPETENCES'
export const GET_CURRENT_COMPETENCE = 'contract_closing/GET_CURRENT_COMPETENCE'
export const GET_EXPECTED_CLOSING_DATE = 'contract_closing/GET_EXPECTED_CLOSING_DATE'
export const SEARCH_CLOSING_EXCEPTIONS = 'contract_closing/SEARCH_CLOSING_EXCEPTIONS'
export const EXPORT_CLOSING_EXCEPTIONS = 'contract_closing/EXPORT_CLOSING_EXCEPTIONS'
export const GET_CLOSING_EXCEPTION_CATEGORIES = 'contract_closing/GET_CLOSING_EXCEPTION_CATEGORIES'
export const SAVE_CLOSING_EXCEPTION = 'contract_closing/SAVE_CLOSING_EXCEPTION'
